import { Checkbox } from "@/components/ui/checkbox";

interface TermsCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  error?: string;
  id?: string;
}

/** "I agree to the Terms and Privacy Policy" — the one consent every account and candidate gives. */
export function TermsCheckbox({ checked, onCheckedChange, error, id = "accept-terms" }: TermsCheckboxProps) {
  return (
    <div className="grid gap-1.5">
      <div className="flex items-start gap-2.5">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(value === true)}
          aria-invalid={error ? true : undefined}
          className="mt-0.5"
        />
        <label htmlFor={id} className="text-sm leading-snug">
          I agree to the{" "}
          <a
            href="/terms"
            target="_blank"
            rel="noreferrer"
            className="font-medium text-brand underline-offset-4 hover:underline"
          >
            Terms
          </a>{" "}
          and{" "}
          <a
            href="/privacy"
            target="_blank"
            rel="noreferrer"
            className="font-medium text-brand underline-offset-4 hover:underline"
          >
            Privacy Policy
          </a>
        </label>
      </div>
      {error && <p className="text-[13px] text-destructive">{error}</p>}
    </div>
  );
}
